import { AddOnCounter } from '@ps-design-system/components/AddOnCounter';
import { useMediaQuery } from '@ps-design-system/lib/hooks/use-media-query';
import PropTypes from 'prop-types';
import React from 'react';
import { AddOnsDialog } from './AddOnsDialog';

const createAddOnItem = (item, currency) => {
  return {
    id: item._id,
    label: item.label,
    categoryId: item.category,
    cost: item.unit_cost,
    costBasis: item.unit_cost_basis,
    description: item.description,
    max: item.count || undefined, // max defaults to 0 on BE if host doesn't specify a max
    image: item.image_ids?.[0]
      ? `https://img.peerspace.com/image/upload/${item.image_ids?.[0]}.jpg`
      : '',
    fees: item.additional_costs,
    currency
  };
};

export const AddOnsFormFields = ({
  inventory,
  watchFormValues,
  addOnsTotalCost,
  currency,
  isFetchingQuote,
  disabled,
  intl
}) => {
  const items = (inventory || []).map((item) =>
    createAddOnItem(item, currency)
  );

  const isMobile = useMediaQuery('(max-width: 576px)');

  const totalVisible = isMobile ? 2 : 5;

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          marginBottom: '24px'
        }}
      >
        {items.slice(0, totalVisible).map((item) => {
          return (
            <AddOnCounter
              key={item.id}
              addOnItem={item}
              name={`addOns.${item.id}`}
              testId={`add-ons-${item.id}`}
              intl={intl}
              disabled={disabled}
            />
          );
        })}
      </div>
      {items.length > totalVisible && (
        <AddOnsDialog
          items={items}
          watchFormValues={watchFormValues}
          addOnsTotalCost={addOnsTotalCost}
          currency={currency}
          isFetchingQuote={isFetchingQuote}
          isMobile={isMobile}
          disabled={disabled}
        />
      )}
    </div>
  );
};

AddOnsFormFields.displayName = 'AddOnsFormFields';
AddOnsFormFields.propTypes = {
  inventory: PropTypes.arrayOf(PropTypes.object),
  watchFormValues: PropTypes.func.isRequired,
  addOnsTotalCost: PropTypes.number,
  currency: PropTypes.string,
  isFetchingQuote: PropTypes.bool,
  intl: PropTypes.object
};
